// Transpacific Software - all common js code here

$('.tps_clab_header .header__inline-menu li header-menu details').mouseenter(function(){
	$(this).attr('open', true);		
});
$('.tps_clab_header .header__inline-menu li header-menu details').mouseleave(function(){
	$(this).removeAttr('open', true);		
});

// top header search
  var topHeight = $("header").outerHeight();
  console.log(topHeight);
 $('.search-modal.modal__content').css('top', topHeight);

// home page featured collection slider
$('.tps_featured_collection ul.product-grid').slick({
  dots: false,
  infinite: true,
  slidesToShow: 4,
  adaptiveHeight: true,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        infinite: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        infinite: true
      }
    },    
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});


// jewelery collection slider
if($(window).width() < 768){
    $('.tps_home_shop_diamonds_container ul').slick({
        dots: false,  
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '20px',
        responsive: [  
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      });

  // jewelery collection slider
  $('.tps_home_collection_list ul.collection-list').slick({
    dots: false,
    
    infinite: true,
    slidesToShow: 2,
    adaptiveHeight: true,
    slidesToScroll: 1,
    responsive: [      
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
}

